import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', '?'));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login');
      return;
    }

    (async () => {
      try {
        const resp = await api.post('/auth/google', { session_id: sessionId });
        if (resp.data.token) {
          localStorage.setItem('mayr_ops_token', resp.data.token);
        }
        await checkAuth();
        navigate('/dashboard', { replace: true });
      } catch (err) {
        console.error('Google auth failed:', err);
        navigate('/login?error=oauth_failed', { replace: true });
      }
    })();
  }, [navigate, checkAuth]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-4">
        <div className="w-12 h-12 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="text-muted-foreground font-mono text-sm">Authenticating...</p>
      </div>
    </div>
  );
}
